import React, { Component } from 'react';
import { Form, Input, DatePicker } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import moment, { isMoment } from 'moment';

import { InputNumber } from '../../../../components/common/input-number'

export class CarLicense extends Component {

    render() {
        const { editable } = this.props;
        return <>
            <Form.Item
                wrapperCol={15}
                className="alignment"
                name='start_using_date'
                label='Ngày bắt đầu sử dụng::'
                rules={[
                    // {
                    //     required: true,
                    //     message: `Vui lòng chọn Ngày bắt đầu sử dụng!`,
                    // }
                ]}>
                <DatePicker
                    disabled={!editable}
                    // inputReadOnly
                    dropdownClassName="date-picker-dropdown-top"
                    getPopupContainer={node => {
                        if (node) {
                            return node.parentNode;
                        }
                        return document.body;
                    }} format='DD/MM/YYYY' className="dropdown-full" />
            </Form.Item>
            <Form.Item
                wrapperCol={15}
                className="alignment"
                name='registry_id'
                label='Số đăng ký::'
                rules={[]}
            >
                <Input disabled={!editable} placeholder='Số đăng ký' />
            </Form.Item>
            <Form.Item
                wrapperCol={15}
                className="alignment"
                name='license_expiry_date'
                label='Ngày hết hạn giấy đi đường::'
                rules={[
                ]}>
                <DatePicker
                    disabled={!editable}
                    // inputReadOnly
                    dropdownClassName="date-picker-dropdown-top"
                    getPopupContainer={node => {
                        if (node) {
                            return node.parentNode;
                        }
                        return document.body;
                    }} format='DD/MM/YYYY' className="dropdown-full" />
            </Form.Item>
            <Form.Item
                wrapperCol={15}
                className="alignment"
                name='next_registry_date'
                label='Ngày đăng kiểm tới::'
                rules={[
                ]}>
                <DatePicker
                    disabled={!editable}
                    // inputReadOnly
                    dropdownClassName="date-picker-dropdown-top"
                    getPopupContainer={node => {
                        if (node) {
                            return node.parentNode;
                        }
                        return document.body;
                    }} format='DD/MM/YYYY' className="dropdown-full" />
            </Form.Item>
            <Form.Item
                wrapperCol={15}
                name='insurrance_nummber'
                className="alignment"
                label='Số bảo hiểm bắt buộc::'
                rules={[]
                }
            >
                <Input disabled={!editable} placeholder='Số bảo hiểm bắt buộc' />
            </Form.Item>
        </>
    }
}